import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-battery',
  templateUrl: './battery.component.html',
  styleUrls: ['./battery.component.css']
})
export class BatteryComponent {
  @Input() batteryLevel = 0;
  @Input() width = 100;
}
